import http from "@/http";
import cookies from 'vue-cookies';
import * as types from "./types";

const actions = {

  [types.VALIDATE_PASSCODE](context, { passcode, counter = false }) {
    const campaignId = context.state.campaignId;
    const params = {
      campaign_id: campaignId,
      code: passcode,
      counter: counter
    };

    const url = context.rootState.endPoints.customizer.validatePasscode;

    return new Promise((resolve, reject) => {
      http
        .get(url, { params })
        .then(response => response.data)
        .then(data => {
          const expirationDate = new Date(data.expiration);

          if (expirationDate >= new Date()) {
            context.commit(types.SET_PASSCODE, passcode);
            context.commit(types.SET_PASSCODE_IS_VALID, true);
            context.commit(types.SET_PALETTE_ID, data.palette_id);
            context.commit(types.SET_EXPIRATION_DATE, expirationDate);
            context.commit(types.SET_CAMPAIGN_IS_EXPIRED, false);

            context.dispatch(types.SET_COOKIE);

            resolve({
              isPasscodeValid: true,
              isCampaignExpired: false,
            });
          } else {
            context.commit(types.SET_PASSCODE_IS_VALID, false);
            context.commit(types.SET_CAMPAIGN_IS_EXPIRED, true);

            resolve({
              isPasscodeValid: false,
              isCampaignExpired: true,
            });
          }
        })
        .catch(err => {
          context.commit(types.SET_PASSCODE_IS_VALID, false);
          resolve({
            isPasscodeValid: false,
            isCampaignExpired: false,
          });
        });
    });
  },

  [types.VALIDATE_CAMPAIGN_ID](context) {
    const campaignId = context.state.campaignId;
    const params = {
      campaign_id: campaignId,
    };
    const url = context.rootState.endPoints.customizer.validatePasscode;

    return new Promise((resolve, reject) => {
      http
        .get(url, { params })
        .then(() => {
          context.commit(types.SET_CAMPAIGN_IS_VALID, true);
          resolve(true);
        })
        .catch(err => {
          context.commit(types.SET_CAMPAIGN_IS_VALID, false);
          resolve(false);
        });
    });
  },

  [types.SET_COOKIE](context) {
    const { campaignId, passcode, expirationDate } = context.state;
    cookies.set(`customs_campaign_id_${campaignId}`, passcode, expirationDate.toUTCString());
  },

  [types.REMOVE_COOKIE](context) {
    const campaignId = context.state.campaignId;
    cookies.remove(`customs_campaign_id_${campaignId}`);
  },
};

export default actions;
